import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE_URL}/api`,
});

// Attach token from localStorage on every request.
// Customer routes get the customer token; everything else gets the admin token.
api.interceptors.request.use((config) => {
  const url = config.url || '';
  const isCustomerCall = url.startsWith('/customer/') || url.includes('/customer/auth/');
  const key = isCustomerCall ? 'elite_customer_token' : 'elite_admin_token';
  const token = localStorage.getItem(key);
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-redirect to /admin/login on 401 from admin endpoints
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const isAdminCall = err?.config?.url?.includes('/admin/') || err?.config?.url?.includes('/auth/me');
    if (err?.response?.status === 401 && isAdminCall) {
      localStorage.removeItem('elite_admin_token');
      if (window.location.pathname.startsWith('/admin') && !window.location.pathname.endsWith('/login')) {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(err);
  }
);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};
